import React, { Component } from 'react';
import PropTypes from 'prop-types';

const faChevronDown = (<svg className="svgArrowRecommend" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="m12.002 15.948 5.656-5.666a.752.752 0 0 0 0-1.062.75.75 0 0 0-1.06 0L12 13.928 7.405 9.22a.75.75 0 0 0-1.06 0 .752.752 0 0 0 0 1.062l5.657 5.666z" fill="#767676" />
</svg>
)
const faChevronUp = (<svg className="svgArrowRecommend hidden" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="m12.002 8.55 5.656 5.666a.752.752 0 0 1 0 1.062.75.75 0 0 1-1.06 0L12 10.57l-4.595 4.708a.75.75 0 0 1-1.06 0 .752.752 0 0 1 0-1.062l5.657-5.666z" fill="#767676" />
</svg>
)


class ToggleSelect extends Component {
    
    state = {
        isOpen: this.props.isOpen
      }

    toggle = () => {
        const targetSelect = this.props.selectRef.current;
        if (targetSelect.props.menuIsOpen) {
            targetSelect.onMenuClose();
            this.setState( {isOpen: false});
        } else {
            targetSelect.onMenuOpen();
            this.setState( {isOpen: true});
        }

        let arrows;
        if (this.props.isFrom === "sidebar") {
            arrows = document.querySelectorAll('.sidebar .svgArrowRecommend');
        } else {
            arrows = document.querySelectorAll('.options .svgArrowRecommend');
        }
        for (const arrow of arrows) {
            arrow.classList.toggle('hidden');
        }
    }


    render = () => (
        <div className={this.props.className}
        onClick={this.toggle}>
        <div className={this.props.iconClassName}>
        {faChevronUp}
        {faChevronDown}
        </div>
        <button
          className={this.props.className}
            
        >
            {this.props.children}
        </button>
        </div>
    )
}

ToggleSelect.propTypes = {
    selectRef: PropTypes.shape({
        current: PropTypes.shape({
            props: PropTypes.shape({
                menuIsOpen: PropTypes.bool,
            }),
            onMenuClose: PropTypes.func,
            onMenuOpen: PropTypes.func,
        })
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    isFrom: PropTypes.string,
    children: PropTypes.node,
};

export default ToggleSelect